<div class="app__container mt-10 flex flex-col gap-6">
	<div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
		<h2 class="flex text-left text-primary-900">Clientes</h2>
		@if (isSuperAdmin) {
			<activar-button
				text="Nuevo usuario"
				fill="solid"
				color="primary"
				(click)="goToCreateAdmin()"
			/>
		}
	</div>

	<activar-tabs
		[tabs]="tabs"
		(switch)="switchTab($event)"
		[activeTab]="activeTab()"></activar-tabs>

	<div class="flex flex-col md:flex-row gap-4 w-full md:w-[600px]">
		<app-search-users />
	</div>

	@if (loading()) {
		<app-users-table-skeleton />
	} @else {
		@if (usersStore.hasProspectFilter()()) {
			<app-prospects-table
				class="overflow-x-auto" />
		} @else {
			<app-users-table
				class="overflow-x-auto" />
		}
	}

	<app-pagination
		[paginationStore]="paginationStore"
		(pageChange)="changePage()" />
</div>
